import { c as _c } from "react/compiler-runtime";
import { useStore } from 'modules/stores/store/hooks/use-store';
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query';
export const useDeleteItem = () => {
  const $ = _c(3);
  const {
    storeId,
    redirectToMainPage
  } = useStoreQuery();
  const {
    mutate
  } = useStore(storeId);
  let t0;
  if ($[0] !== mutate || $[1] !== redirectToMainPage) {
    const onDelete = async t1 => {
      const {
        deleteCallback,
        itemId,
        shouldRedirectToMainPage
      } = t1;
      await deleteCallback();
      await mutate(data => data && {
        ...data,
        items: data.items.filter(item => item.itemId !== itemId)
      }, false);
      if (shouldRedirectToMainPage) {
        await redirectToMainPage();
      }
    };
    t0 = {
      onDelete
    };
    $[0] = mutate;
    $[1] = redirectToMainPage;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};